import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MapPin, Clock, Facebook, Instagram, PaintBucket } from 'lucide-react';

const PaintingFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-[#1E3A8A] rounded-lg flex items-center justify-center">
                <PaintBucket className="w-6 h-6" />
              </div>
              <div>
                <h3 className="text-xl font-bold">D'este Painting</h3>
                <p className="text-sm text-gray-400">& Service</p>
              </div>
            </div>
            <p className="text-gray-400 leading-relaxed mb-4">
              Professional painting services in Hollywood, FL and surrounding areas. Quality work, honest pricing, exceptional results.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-[#1E3A8A] rounded-lg flex items-center justify-center hover:bg-[#EA580C] transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="w-10 h-10 bg-[#1E3A8A] rounded-lg flex items-center justify-center hover:bg-[#EA580C] transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-lg font-bold mb-4">Quick Links</h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/services" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  Services
                </Link>
              </li>
              <li>
                <Link to="/gallery" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  Gallery
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-4">Our Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li>Residential Interior</li>
              <li>Residential Exterior</li>
              <li>Commercial Painting</li>
              <li>Cabinet Refinishing</li>
              <li>Deck Staining</li>
              <li>Pressure Washing</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold mb-4">Contact Us</h4>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-[#EA580C] mt-1 flex-shrink-0" />
                <div>
                  <p className="text-gray-400">1841 Rodman St</p>
                  <p className="text-gray-400">Hollywood, FL 33020</p>
                </div>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-[#EA580C] flex-shrink-0" />
                <a href="tel:+19548172046" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  (954) 817-2046
                </a>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-[#EA580C] flex-shrink-0" />
                <a href="mailto:info@destepaintingservice.com" className="text-gray-400 hover:text-[#EA580C] transition-colors">
                  info@destepaintingservice.com
                </a>
              </div>
              <div className="flex items-start space-x-3">
                <Clock className="w-5 h-5 text-[#EA580C] mt-1 flex-shrink-0" />
                <div className="text-gray-400">
                  <p>Mon-Fri: 7AM - 6PM</p>
                  <p>Sat: 8AM - 4PM</p>
                  <p>Sun: Closed</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center text-gray-400">
          <p>&copy; {currentYear} D'este Painting and Service. All rights reserved.</p>
          <p className="mt-2 text-sm">Licensed & Insured | Serving Hollywood, FL and Surrounding Areas</p>
        </div>
      </div>
    </footer>
  );
};

export default PaintingFooter;
